<template>
    <!-- <nav id="colorlib-main-menu" style="text-align: initial" role="navigation" aria-label="Main menu" class="arabic-mclassic">
        <ul v-if="languageData && menuItems ">
            <li class="menu-top-normal">
                <router-link class="menu_accessi" :to="'/'" v-html="languageData['d00']" ></router-link>
            </li>

            <li v-for="(men, key) in menuItems" :key="key">

                <router-link @focus.native="focusin()" class="menu_accessi"  :to="'/division/'+key.trim()" :key="key" v-html="languageData['d'+key.trim().toString()]"></router-link>    
            </li>
        </ul>
        <ul v-else>
            <li @click="showCosmicMenu()">Loading...</li>
        </ul>
    </nav> -->

    <nav id="colorlib-main-menu" role="navigation" aria-label="Main menu" class="arabic-mclassic navbar navbar-expand-lg navbar-dark nav-margin main-div">
    <div class="container-fluid main-div">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="" id="">
            <ul class="navbar-nav nav-ul" v-if="languageData && menuItems ">
               
                <!-- <mdb-dropdown tag="li" class=" ">
                    <mdb-dropdown-toggle tag="a" slot="toggle" class="btn-dropdown menu_accessi" style="color:black">Home</mdb-dropdown-toggle>
                </mdb-dropdown> -->
      
                <mdb-dropdown tag="li" v-for="(men, key) in menuItems" :key="key">
                    <router-link v-if="men['is_this_homepage']==1 " @focus.native="focusin()" :to="'/'" slot="toggle" class="btn-dropdown" style="color:black" v-html="languageData[men['name']]"></router-link>

                    <mdb-dropdown-toggle v-else-if="men['subset']" @focus.native="focusin()" aria-haspopup="true" tag="a" :href="men['url']" slot="toggle" class="btn-dropdown" style="color:black" v-html="languageData[men['name']]+ down_arrow">
                    </mdb-dropdown-toggle>

                    <a v-else-if="(men['is_this_homepage']==0 && !men['subset'] && men['url_external']==1)" @focus.native="focusin()" aria-haspopup="true" tag="a" slot="toggle" class="btn-dropdown" style="color:black" v-html="languageData[men['name']]" target="_blank" :href="men['url']"> 
                    </a>

                    <router-link v-else-if="(men['is_this_homepage']==0 && !men['subset'] && men['url_external']==0)" @focus.native="focusin()" :to="men['url']" slot="toggle" class="btn-dropdown" style="color:black" v-html="languageData[men['name']]"></router-link>

                    <mdb-dropdown-menu class="drop-nav" v-if="men['subset']">
                        <template v-for="(submen, key) in men['subset']">
                            <mdb-dropdown-item v-if="submen['url_external']==1" v-html="languageData[submen['name']]" :href="submen['url']" target="_blank"></mdb-dropdown-item>
                            <router-link v-else class="dropdown-item" :to="submen['url']" v-html="languageData[submen['name']]" ></router-link>
                        </template>
                    </mdb-dropdown-menu>

                </mdb-dropdown>


     <!-- <mdb-dropdown tag="li">
    <mdb-dropdown-toggle tag="a" class="btn-dropdown" slot="toggle">Legal & Financial Support<img :src="'/img/ios-arrow-down.svg'" alt="" class="icon-arrow"></mdb-dropdown-toggle> 
     <mdb-dropdown-menu  class="drop-nav">
      <mdb-dropdown-item>Action</mdb-dropdown-item>
      <mdb-dropdown-item>Another action</mdb-dropdown-item>
      <mdb-dropdown-item>Something else here</mdb-dropdown-item>
    </mdb-dropdown-menu>
      </mdb-dropdown> -->
        </ul>
        <ul v-else>
            <li @click="showCosmicMenu()">Loading...</li>
        </ul>
        </div>
    </div>
</nav>

</template>
<script>
 import { mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle, mdbDropdownItem } from 'mdbvue';
    export default{
        name:'MainMenu',
        data: function() {
            return {
                LOCAL_HOST:this.$store.state.LOCAL_HOST,
                RTL_LANG:this.$store.state.RTL_LANG,
                //showLiveConnect:this.$store.state.hideLiveConnectfloat,
                aria_val:[],
                lang_id:localStorage.id_language
               //isActive: false,
                //offcanvas: false
            }
        },

        computed:{
            languageData(){return this.$store.state.languageData;},
            down_arrow(){return '<img src="/img/ios-arrow-down.svg" alt="" class="icon-arrow">';},
            menuItems(){
                return this.$store.state.cosmicMenu;
            },
            themelogic(){return this.$store.state.themeLogic},
            companyDataInfo(){return this.$store.state.companyDataInfo},
            liveConnectCsAr(){ if(this.RTL_LANG.includes(this.lang_id)) {return ' live-connect-cs-ar'}else{return '';}}
        },
        components: {
            mdbNavbar,
            mdbNavbarBrand,
            mdbNavbarToggler,
            mdbNavbarNav,
            mdbNavItem,
            mdbDropdown,
            mdbDropdownMenu,
            mdbDropdownToggle,
            mdbDropdownItem
        }, 
          
        mounted:function(){
            this.showCosmicMenu()
        },
        methods: {
            showCosmicMenu(){
                this.$store.dispatch('getCosmicMenu');
                /*setTimeout(function () {
                    
                    console.log("doneggggggggggggg");
            }, 10000);*/
                
                //console.log('homeContent'+this.languageData);
            },
            openNewWindow:function(){
                var link='https://rms.workplaceoptions.com/anonymouschat/'+this.companyDataInfo['rms_system']+"/"+this.companyDataInfo['rms_company']+"/"+this.companyDataInfo['rms_service']+"/"+this.companyDataInfo['id_language_rms']+"?id_company="+this.$store.state.companyData['id_company']+"&name_company="+this.$store.state.companyData['name_company'];
                //console.log("getting here"+screen.width+'-h-'+screen.height);             
                window.open(link,'menu', 'location');                
            },
            
            toggleMegaMenu:function(activa){
                // alert('in menu-'+window.innerWidth);
               activa= ! activa
                if(activa){
                    this.toggleBodyClass('addClass','offcanvas')
                }
                else{
                    this.toggleBodyClass('removeClass','offcanvas')
                }
                 
                //this.$emit(activa)
                return activa
            },
            toggleBodyClass(addRemoveClass, className) {
                /*this.showLiveConnect="live-connect-normal";//live connect as normal link in mobile view
                //alert('tt insider');
                const el = document.body;
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }*/
            },
            hideme(event){
               // alert('test');
               /*this.showLiveConnect="live-connect-normal";
               this.$store.state.hideLiveConnectfloat='live-connect-normal';
               //event.stopPropagation()
               event.preventDefault() */              
            },
            focusin() {
                document.body.classList.add('offcanvas');
            }
        }
    }; 
</script>

<style scoped>
.router-link-exact-active{
    /* color: #fff !important;  */
    color: #5d5d5d !important;
    font-weight: bold !important;
}
.live-connect-cs{
    position: fixed !important;
    bottom: 0 !important;
    right: 0 !important;
}
.live-connect-cs-ar{   
    left: 1px !important;
    right: unset !important;
}
.live-connect-normal img{
    width: 106px !important;
}
.live-connect-normal:after{
    height: 0px !important;
}
.live-connect-cs:after{
    height: 0px !important;
        /* width: 10px !important;
    height: 10px !important;
    color: black;
    background: black !important;
    position: absolute !important; */
}
.live-connect-cs button{
    width: 17px !important;
    height: 16px !important;
    /* background: black !important; */
    position: relative;
    /* color: black; */
    /* margin: 10px; */
    z-index: 999999;
    left: -18px;
    top: -16px;
    border: none;
    line-height: 1px;
    font-size: 10px;
    font-weight: bold;
}
nav ul li {
    display: inline-block;
    box-sizing: border-box;
    z-index: 999;
    height:100%;
    /* border-left: 0.01em solid #c3c3c38c; */
    /* border-left: 1px solid #919294; */
    padding-left: 10px;
    padding-right: 10px;    
}
nav ul {
    padding: 12px 0px;
    margin: 0px;
}
nav ul li a {
   color:rgb(28 28 28); /* rgb(89 89 89); */
}
nav ul li a:hover {
    font-weight: bold !important;
}
#colorlib-main-menu{
    /* background-color: #1B4A83 !important; */
}
.menu-top-normal {
    margin-top: 10px;
}
@media only screen and (max-width: 768px){
    nav {
        width: min-content;
    }
    .router-link-exact-active{
        color: #5d5d5d !important; 
    }
    nav ul li a {
        color: rgb(0, 0, 0) !important;
    }
    
}
@media only screen and (min-width: 768px){
    nav ul li {
        border-left: 0.01em solid #c3c3c38c;
    }
}

:focus {
    outline: none !important;
    border: none !important;
    outline-offset: none !important;
  }
.btn-dropdown {
    border-radius: 0; 
    box-shadow: none
}
.brd-right {
    padding-left: 20px;
    color: #000000;
    font-size: 16px;
}
.navbar {
    min-height: auto !important;
 
}
.drop-nav{
    margin-top: 15px;
    padding: 0px !important;
}.drop-nav a{
    font-size: 14px;
    color: #000;
    padding: 6px 45px !important;
    border-bottom: 1px solid #ccc;
    padding-left: 12px !important;
}
.navbar-nav {
    display: flex;
}
@media only screen and (max-width: 1400px) and (min-width: 1200px) {
    .main-div {
        padding-left: 0 !important;
    }
    .nav-ul li {
    padding: 0px 0px;
}
}
@media only screen and (max-width: 1200px) and (min-width: 992px){
.main-div {
        padding-left: 0 !important;
    }
    .nav-ul li {
    padding: 0px 0px;
}
.nav-ul li a{
    font-size: 10px;
}
}



.navbar-bg{

    background-color: #F8F8F8 !important;

    border:1px solid #DDDDDD;

}

.nav-ul li a{

    color: #000000 !important;

    font-size: 14px;

    padding: 0px;

}
 
 
.nav-ul li {

    border-right: 1px solid #000000;

    padding: 0 20px;

}

.nav-ul li span a {

    text-transform: capitalize;

}

.nav-ul li:last-child {

  border-right: none;

}

.nav-ul li:first-child {

padding-left: 0;

}

.drop-nav{

    margin-top:8px !important;

}

.drop-nav li{

    border: none;

}

.dropdown-toggle::after {

            display: none !important;

        }

.icon-arrow{

    padding-left: 12px;

}

.nav-margin {

    /* margin-bottom: none !important; */

    box-shadow: none !important;

}

nav{

    margin-bottom: 0 !important;

}

nav ul li {

    border-left: 0 !important;

}
</style>
